<template>
  <div class="pt-4 pb-4">
    <p class="text-lg font-bold px-6" v-if="title">
      {{ title }}
    </p>
    <el-form :model="pwdForm" :rules="rules" ref="pwdForm" label-position="top" class="p-6" @submit.prevent.native="setPassword('pwdForm')">
      <el-form-item label="Password" prop="pass">
        <el-input type="password" v-model="pwdForm.pass"></el-input>
      </el-form-item>
      <el-form-item label="Confirm Password" prop="checkPass">
        <el-input type="password" v-model="pwdForm.checkPass"></el-input>
      </el-form-item>
      <el-form-item class="flex justify-between">
        <el-button native-type="submit" type="primary">Create Password</el-button>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
export default {
  data() {
    const validatePass = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('Please add your password'));
      } else {
        if (this.pwdForm.checkPass !== '') {
          this.$refs.pwdForm.validateField('checkPass');
        }
        callback();
      }
    };
    const validateConf = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('Please input the password again'));
      } else if (value !== this.pwdForm.pass) {
        callback(new Error('This password is different'));
      } else {
        callback();
      }
    };
    return {
      pwdForm: {
        pass: '',
        checkPass: '',
      },
      rules: {
        pass: [{ validator: validatePass, trigger: 'blur' }],
        checkPass: [{ validator: validateConf, trigger: 'blur' }],
      },
    };
  },
  props: {
    title: String,
    note: String,
    action: {
      type: Function,
      required: true,
    },
  },
  methods: {
    async setPassword(formName) {
      try {
        this.$refs[formName].validate(async (valid) => {
          if (valid) {
            this.action({ password: this.pwdForm.pass });
            this.$emit('onClose');
          }
          return valid;
        });
      } catch (error) {
        this.error = error;
      }
    },
  },
};
</script>
